import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { of } from 'rxjs'
import useObservable from 'libraries/front-end-core/hooks/useObservable'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import { requestAllSectionDocuments } from 'services/DocumentService'
import { requestUserFavourites } from 'services/FavouritesService'
import { DOCUMENTS_FAVOURITING } from 'constants/feature-flags'
import SectionsDocumentsList from 'components/documents/SectionsDocumentsList'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import DocumentsAllSkeleton from './DocumentsAllSkeleton'

function filterToFavourites (data, favouritesSet) {
  return data.reduce((acc, section) => {
    const visibleSubsections = section.sections.reduce((sacc, subsection) => {
      const documents = subsection.documents.filter(doc => favouritesSet.has(doc.id))
      if (documents.length === 0) return sacc
      return [...sacc, { ...subsection, documents }]
    }, [])
    if (visibleSubsections.length === 0) return acc
    return [...acc, { ...section, sections: visibleSubsections }]
  }, [])
}

export default function DocumentsAll (props) {
  const showFavouritesOnly = useSelector(state => state.documents.showFavouritesOnly)
  const showAutomatedOnly = useSelector(state => state.documents.showAutomatedOnly)

  const data = useObservable(
    requestAllSectionDocuments('corporate', showAutomatedOnly),
    RESPONSE_PENDING,
    [showAutomatedOnly]
  )
  const documentFavourites = useObservable(
    DOCUMENTS_FAVOURITING ? requestUserFavourites('documents') : of([]),
    RESPONSE_PENDING
  )

  const favouritesSet = useMemo(
    () => new Set(Array.isArray(documentFavourites) ? documentFavourites : []),
    [documentFavourites]
  )

  // Pre-computed once when data/favourites arrive — toggle is a free reference swap
  const favouritesData = useMemo(
    () => Array.isArray(data) ? filterToFavourites(data, favouritesSet) : [],
    [data, favouritesSet]
  )

  const displayData = Array.isArray(data) ? (DOCUMENTS_FAVOURITING && showFavouritesOnly ? favouritesData : data) : []

  return (
    <ResponseConsumer
      response={data}
      pendingComponent={() => (
        <div className='layout-width-constraint'>
          <DocumentsAllSkeleton />
        </div>
      )}
      content={() => (
        <div className='layout-width-constraint'>
          {DOCUMENTS_FAVOURITING && showFavouritesOnly && displayData.length === 0
            ? (
              <p className='f2 tc i'>
                {showAutomatedOnly ? 'No automated favourites selected' : 'No favourites selected'}
              </p>
              )
            : (
              <SectionsDocumentsList data={displayData} favourites={favouritesSet} />
              )}
        </div>
      )}
    />
  )
}
